import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/navbar";
import Footer from "../Footer/footer";
import FooterDoodles from "../Footer/footerDoodles";
import icons from "../../icons.config";
import { fetchExchangeAndReturnPolicy } from "../../Providers/staticFileProvider"; // ✅ Import API function

const ExchangeAndReturn = () => {
  const [exchangeAndReturn, setExchangeAndReturn] = useState("");

  useEffect(() => {
    const getPolicy = async () => {
      const policyText = await fetchExchangeAndReturnPolicy();
      setExchangeAndReturn(policyText || "No policy available.");
    };

    getPolicy();
  }, []);

  return (
    <>
      <Navbar />
      <section className="flex flex-col justify-center items-center w-full h-full bg-tertiary pt-10 md:pt-3 lg:pt-0 lg:-mt-5 relative pb-0 overflow-hidden">
        <div className=" lg:block relative left-[60%] md:left-[45%]  lg:left-[45%] z-10">
          <img src={icons.trendCircles} alt="Doodle Left" className="w-[40%] md:w-[60%] lg:w-[70%]" />
        </div>
      </section>

      <section className="bg-tertiary">
        {/* Privacy Policy Title */}
        <div className="flex justify-center items-center relative bottom-12 md:bottom-14 lg:bottom-24">
          <h1 className="text-primary1 font-outfit text-2xl md:text-3xl lg:text-4xl font-light ">
            EXCHANGE AND RETURN POLICY
          </h1>
        </div>

        {/* Policy Content */}
        <div className="px-12 md:px-12 lg:px-24 xl:px-32 text-left z-20 pb-10 lg:-mt-10">
          {exchangeAndReturn ? (
            <p className="text-base text-gray-700 mt-2 whitespace-pre-line">{exchangeAndReturn}</p>
          ) : (
            <p className="text-gray-500">Loading privacy policy...</p>
          )}
        </div>
      </section>

      <FooterDoodles />
      <Footer />
    </>
  );
};

export default ExchangeAndReturn;
